import { Component, OnInit, Input } from '@angular/core';
import { JobService } from '../../../../services/job/job.service';

// Overview: Report Payment / Proofed / Job In Scheduling switches (the right half of
// overview/items/item-seven). The switches are hidden from inspectors, as before.
// The order log link (overview/items/item-order-history) is in the Notes panel footer.
@Component({
  selector: 'app-overview-action',
  templateUrl: './overview-action.component.html',
  styleUrls: ['./overview-action.component.scss']
})
export class OverviewActionComponent implements OnInit {
  @Input() job: any;
  userData;
  isChecked: boolean = false;
  isCheckedProof: boolean = false;
  isCheckedScheduling: boolean = false;

  constructor(public jobService: JobService) {}

  ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('user'));
    this.isChecked = this.job.report_payment_status == 1 ? true : false;
    this.isCheckedProof = this.job.proofed_status == 1 ? true : false;
    this.isCheckedScheduling = this.job.job_in_scheduling == 1 ? true : false;
  }

  // No / Yes buttons: only a change of value saves, as the old checkbox's (change) did.
  setPayment(value: boolean) {
    if (this.isChecked !== value) {
      this.isChecked = value;
      // The Overview's Payment Status chip reads the same job object.
      this.job.report_payment_status = value ? 1 : 0;
      this.onToggleChange(null);
    }
  }

  setProofed(value: boolean) {
    if (this.isCheckedProof !== value) {
      this.isCheckedProof = value;
      this.onToggleChangeProof(null);
    }
  }

  setScheduling(value: boolean) {
    if (this.isCheckedScheduling !== value) {
      this.isCheckedScheduling = value;
      this.onToggleChangeScheduling(null);
    }
  }

  onToggleChange(e) {
    let paymentStatus = this.isChecked == true ? "recieved" : "not-recieved"
    this.jobService.changeJobReportPayment({report_payment_status : paymentStatus} ,this.job.job_id).subscribe(
      data => {
      }
    );
  }

  onToggleChangeProof(e) {
    let paymentStatus = this.isCheckedProof == true ? "yes" : "no"
    this.jobService.changeJobProofedStatus({proofed_status : paymentStatus} ,this.job.job_id).subscribe(
      data => {
      }
    );
  }

  onToggleChangeScheduling(e) {
    let status = this.isCheckedScheduling == true ? "yes" : "no"
    this.jobService.changeJobSchedulingStatus({job_in_scheduling : status} ,this.job.job_id).subscribe(
      data => {
      }
    );
  }
}
